/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect } from "react";
import { Button, Tabs } from "antd";
import { FlexBox, TabWrapper } from "src/styles/common";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchIWApplicationDetails, IWBrandState, setEditModal } from "@redux/brandOperation/intoWarehouseBrandSlice";
import PageTitle from "@component/PageTitle";
import EditTab from "./EditTab";
import ProductTab from "./ProductTab";

const IntoWarehouseReview = () => {
  const dispatch = useDispatch();
  const { id: applicationId } = useParams();
  const { editModal, intoWarehouseDetails } = useSelector(IWBrandState);

  const operations = (
    <FlexBox>
      <Button onClick={() => window.open(intoWarehouseDetails?.matoLink)} disabled={!intoWarehouseDetails?.matoLink}>
        列印麥頭
      </Button>
      {/* <Button
        type="primary"
        onClick={() => dispatch(setEditModal(!editModal))}
        disabled={!!intoWarehouseDetails?.stoNumber}
      >
        編輯
      </Button> */}
    </FlexBox>
  );

  useEffect(() => {
    if (applicationId) {
      dispatch(fetchIWApplicationDetails(Number(applicationId)));
    }
  }, [applicationId, dispatch]);

  return (
    <TabWrapper>
      <PageTitle title="品運進貨" />
      <Tabs type="card" tabBarExtraContent={operations} defaultActiveKey="editType">
        <Tabs.TabPane tab="編輯進倉單" key="editType">
          <EditTab intoWarehouseDetails={intoWarehouseDetails} />
        </Tabs.TabPane>
        <Tabs.TabPane tab="進倉商品" key="productType">
          {intoWarehouseDetails && <ProductTab intoWarehouseDetails={intoWarehouseDetails} />}
        </Tabs.TabPane>
      </Tabs>
    </TabWrapper>
  );
};
export default IntoWarehouseReview;
